// remote host - 185.238.73.35:8080
// export const ENVIRONMENT = {
//     HOST_ADDRESS: 'http://localhost',
//     PORT: ':8443'
// }
export const ENVIRONMENT = {
    HOST_ADDRESS: 'https://api-markoweszczawiny.travelynx.eu',
    PORT: ':8443'
}
